export const EMAIL_MAX_LENGTH = 128;
export const SITE_MAX_LENGTH = 64;
export const NAME_MAX_LENGTH = 64;
export const ADDRESS_MAX_LENGTH = 256;
export const REGION_NAME_MAX_LENGTH = 128;
export const ADDITION_ADDRESS_MAX_LENGTH = 64;
export const HOUSE_NUMBER_MAX_LENGTH = 10;
export const PHONE_NUMBER_MAX_LENGTH = 16;
export const VALIDATOR_NUMBER_LENGTH = 8;
export const AGENCY_CODE_LENGTH = 10;
export const SCREEN_SIZE_MD = 992;
export const SCREEN_SIZE_LG = 1200;
export const SCREEN_SIZE_XL = 1920;
export const ENTITY_TIN_LENGTH = 10;
export const INDIVIDUAL_ENTREPRENEUR_TIN_LENGTH = 12;
export const TIN_MAX_LENGTH = INDIVIDUAL_ENTREPRENEUR_TIN_LENGTH;
export const OGRN_LENGTH = 15;
export const VAT_LENGTH = 20;
export const KPP_LENGTH = 9;
export const BIC_LENGTH = 9;
export const BIC_NOT_RESIDENT_LENGTH = 64;
export const SWIFT_LENGTH = 11;
export const OKPO_MIN_LENGTH = 8;
export const OKPO_MAX_LENGTH = 10;
export const ACCOUNT_LENGTH = 20;
export const ACCOUNT_NOT_RESIDENT_LENGTH = 64;
export const TIN_FORMAT_PATTERN = '^[0-9]{10}$|^[0-9]{12}$';
export const KPP_FORMAT_PATTERN = '^[0-9]{9}$';
export const OGRN_FORMAT_PATTERN = '^[0-9]{13}$|^[0-9]{15}$';
export const EDRPOU_FORMAT_PATTERN = '^[0-9]{8}$';
export const OKPO_FORMAT_PATTERN = `^[0-9]{${OKPO_MIN_LENGTH}}$|^[0-9]{${OKPO_MAX_LENGTH}}$`;
export const WEBSITE_FORMAT_PATTERN = /^(http:\/\/|https:\/\/)?(([a-zA-Z0-9]+|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)+[a-z0-9]+$/;
export const DECIMAL_MONEY_PATTERN = /^(\d{1,3})( \d{3})*(\.\d{2})?$/;
export const TIN_MASK: Array<string | RegExp> = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
export const BIC_MASK: Array<string | RegExp> = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
export const BIC_NOT_RESIDENT_MASK: Array<string | RegExp> = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
export const OKPO_MASK: Array<string | RegExp> = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
export const ACCOUNT_MASK: Array<string | RegExp> = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
export const ACCOUNT_NOT_RESIDENT__MASK: Array<string | RegExp> = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
export const KPP_MASK: Array<string | RegExp> = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
export const RUSSIAN_FEDERATION_ID = 'RU';
export const RUSSIAN_FEDERATION_PHONE_CODE = '7';
export const TOP_CURRENCIES_CODES = [ 'RUB', 'USD', 'EUR' ];

export function  digitOnlyMask(rawValue: string) {
  return Array(rawValue.length || 1).fill(/\d/);
}

export const SPECIAL_REGIONS_WITHOUT_CITY_NAME = ['МОСКВА', 'САНКТ-ПЕТЕРБУРГ', 'СЕВАСТОПОЛЬ'];
